// Copyright (c) 2017 Deere & Company

import React, {Component, PropTypes} from 'react';

/* eslint-disable react/prefer-stateless-function */

class CountCellRenderer extends Component {

    render() {

        return (
            <div className='count-cell-renderer'>
                {this.props.value}
            </div>
        );

    }
}

CountCellRenderer.displayName = 'CountCellRenderer';
CountCellRenderer.propTypes = {
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};
export default CountCellRenderer;



// WEBPACK FOOTER //
// ./src/reports/shared/report-cell-renderers/count-cell-renderer.js